import ReactDOM from "react-dom/client";
import Root from "./root.component";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<Root />);
